import { ARTIST, ADMIN } from 'custom-studio-constants/constants';

export default function isArtist(user, includeAdmins = true) {
	if (!user) return false;
	return user.role === ARTIST || (includeAdmins && user.role === ADMIN);
}
